export const allowOnlyNumbers = (event: React.KeyboardEvent<HTMLInputElement>): void => {
  const isNumberKey = /^\d$/.test(event.key);
  if (!isNumberKey) {
    event.preventDefault();
  }
};
export const handlePasteOnlyNumbers = (event: React.ClipboardEvent<HTMLInputElement>): void => {
  const clipboardData = event.clipboardData;
  const pastedText = clipboardData.getData('text');
  if (!/^\d+$/.test(pastedText)) {
    event.preventDefault();
  }
};
